// MapBox Configuration
export const MAPBOX_TOKEN = 'pk.eyJ1Ijoiam1lZXRiYWp3YSIsImEiOiJjbWIxazVheDQwODZtMmtvbHl5aGc3aDUyIn0.L954OF1pcOhV7W_PNVN40w';

export const MAP_STYLE = 'mapbox://styles/mapbox/streets-v12';

export const DEFAULT_ZOOM = 12;
export const DEFAULT_CENTER = [-79.3832, 43.6532]; // Toronto coordinates as default

export const MARKER_COLOR = '#FF6B6B'; // Primary color for markers 